import request from './axios'
import { API_ENDPOINTS } from './constants'

export const getProfileLoyalty = async () => {
  const response = await request
    .get(API_ENDPOINTS.profileLoyalty)
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}

export const getProfileBalance = async page => {
  const response = await request
    .get(API_ENDPOINTS.profileBalance, {
      params: { page, perPage: 6 }
    })
    .then(({ data }) => data)
    .catch(err => {
      throw err.response
    })

  return response
}
